import { CoreHelper, ActionMetaService } from 'ff-shared-components-core';
import { put } from 'redux-saga/effects';
import { modalOpen, BuildCustomMessageGenericErrorModal, BuildGenericErrorModal } from '@shared/components';
import { Action } from 'typesafe-actions';
import { push } from 'connected-react-router';
import { SCREENS } from '../../routes';
import { ServicesTypes as ST } from '@api/ff-shared-services-api';

export function* handleApiError(
	lng: string,
	err: ST.ResponseError,
	saveError: (err: ST.ResponseError) => Action<string>,
	metaData: ActionMetaService,
	customBusinessHandleError?: (err: ST.ResponseError) => any
): any {
	yield put(saveError(err));

	if (CoreHelper.isNull(customBusinessHandleError) && metaData) {
		if (metaData.showModalError) {
			if (
				err &&
				err.errorType === ST.ErrorType.BUSINESS &&
				err.messages &&
				err.messages.length > 0 &&
				err.messages[0].message
			) {
				yield put(modalOpen(BuildCustomMessageGenericErrorModal(lng, err.messages[0].message)));
			} else {
				yield put(modalOpen(BuildGenericErrorModal(lng)));
			}
		} else if (metaData.isCriticalService) {
			yield put(push(SCREENS.genericError.path));
		}
		return;
	}

	if (customBusinessHandleError !== undefined && customBusinessHandleError !== null) {
		yield customBusinessHandleError(err);
	}
}
